import React, { useState } from 'react';
import { Button, Collapse, ListGroup, ListGroupItem } from 'reactstrap';

const PreAndPostTestGuidelines = () => {
    const [open, setOpen] = useState(false);

    return (
        <section className="py-4">
            <div className='container'>
                <h3>Pre And Post Test Guidelines</h3>
                <Button
                    onClick={() => setOpen(!open)}
                    aria-controls="guidelines-collapse"
                    aria-expanded={open}
                >{open ? 'Hide Guidelines' : 'Show Guidelines'}</Button>
                <Collapse isOpen={open}>
                    <div id="guidelines-collapse">
                        <ListGroup className="mt-3">
                            <ListGroupItem>Brief participants on pre and post-test.</ListGroupItem>
                            <ListGroupItem>The pre and post-test should be made mandatory.</ListGroupItem>
                            <ListGroupItem>Time duration of the pre and post-test should last for 30 minutes.</ListGroupItem>
                            <ListGroupItem>Provide technical assistants to participants during pre and post-test.</ListGroupItem>
                        </ListGroup>

                    </div>
                </Collapse>
            </div>
        </section>
    );
}

export default PreAndPostTestGuidelines;
